import * as React from 'react';
import { DocumentActionsMenu } from 'components/DocumentActionsMenu/DocumentActionsMenu';

export function PreviewActionsMenu(props) {
    const handleClose = (e) => {    
      props.handleMenuOptionClick(e.currentTarget.id, props.rowId);
    };
  
    return (
        <DocumentActionsMenu edit={props?.edit} preview={props?.preview} pdf={props?.pdf} duplicatePdf={props?.duplicatePdf} reinvoice={props?.reinvoice} payment={props?.payment} correction={props?.correction} remove={props?.remove} rowId={props.rowId} isPaid={props.isPaid} handleClose={handleClose} />       
    );
}
